import { render, staticRenderFns } from "./smallOom.vue?vue&type=template&id=55d361d8&scoped=true"
import script from "./smallOom.vue?vue&type=script&lang=js"
export * from "./smallOom.vue?vue&type=script&lang=js"
import style0 from "./smallOom.vue?vue&type=style&index=0&id=55d361d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d361d8",
  null
  
)

export default component.exports